import { Card } from "@/components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const userFlowData = [
  { page: "Homepage", visits: 1200, bounceRate: 35 },
  { page: "Menu", visits: 800, bounceRate: 25 },
  { page: "Reservations", visits: 600, bounceRate: 20 },
  { page: "Events", visits: 400, bounceRate: 30 },
  { page: "Contact", visits: 300, bounceRate: 40 },
];

export const UserFlowChart = () => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">User Flow Analysis</h3>
      <div className="h-[300px]">
        <ChartContainer
          config={{
            visits: {
              label: "Page Visits",
              theme: {
                light: "hsl(var(--primary))",
                dark: "hsl(var(--primary))",
              },
            },
            bounceRate: {
              label: "Bounce Rate",
              theme: {
                light: "hsl(var(--destructive))",
                dark: "hsl(var(--destructive))",
              },
            },
          }}
        >
          <BarChart data={userFlowData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="page" />
            <YAxis yAxisId="left" />
            <YAxis yAxisId="right" orientation="right" />
            <Tooltip content={<ChartTooltipContent />} />
            <Bar
              dataKey="visits"
              yAxisId="left"
              fill="hsl(var(--primary))"
              radius={[4, 4, 0, 0]}
            />
            <Bar
              dataKey="bounceRate"
              yAxisId="right"
              fill="hsl(var(--destructive))"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ChartContainer>
      </div>
    </Card>
  );
};